export const QUERY_PARAMS = {
    ACCOUNT: "account",
    TOUR: "tour",
    GROUP: "group"
} as const;